
import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Line, ComposedChart } from 'recharts';

interface MonthlyReviewData {
  month: string;
  count: number;
  avgRating: number;
}

interface ReviewTrendsChartProps {
  data: MonthlyReviewData[];
}

const ReviewTrendsChart: React.FC<ReviewTrendsChartProps> = ({ data }) => {
  const [timeRange, setTimeRange] = useState<string>("6");
  
  const filteredData = data.slice(-parseInt(timeRange));

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div>
            <CardTitle>Review Trends</CardTitle>
            <CardDescription>Review count and ratings over time</CardDescription>
          </div>
          <Select value={timeRange} onValueChange={setTimeRange}>
            <SelectTrigger className="w-[150px]">
              <SelectValue placeholder="Select range" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="6">Last 6 months</SelectItem>
              <SelectItem value="12">Last 12 months</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardHeader>
      <CardContent>
        <div className="h-[300px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart
              data={filteredData}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis yAxisId="left" orientation="left" />
              <YAxis 
                yAxisId="right" 
                orientation="right" 
                domain={[0, 5]} 
                ticks={[0, 1, 2, 3, 4, 5]} 
              />
              <Tooltip />
              <Legend />
              <Bar 
                yAxisId="left" 
                dataKey="count" 
                fill="#8884d8" 
                name="Review Count" 
                barSize={20}
              />
              <Line 
                yAxisId="right" 
                type="monotone" 
                dataKey="avgRating" 
                stroke="#ff7300" 
                name="Avg Rating" 
                strokeWidth={2}
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default ReviewTrendsChart;
